import { Component, OnInit } from '@angular/core';
import { Dealer, DealerTerm } from 'app/core/model/entity-model';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AppInformationService, GenesisUnitOfWork } from '../../core/core.module';
import { create } from 'lodash';

@Component({
    selector: 'app-dealer-entry-dialog',
    templateUrl: './dealer-entry-dialog.component.html',
    styleUrls: ['./dealer-entry-dialog.component.scss'],
    standalone: false
})
export class DealerEntryDialogComponent implements OnInit {
    result = new Subject<{ success: boolean; dealer?: Dealer; send: boolean }>();
    dealer: Dealer;

    validationGroup = 'dealerEntryValidationGroup';
    errorAction = 'saving';

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork, private appInfo: AppInformationService) {}

    async ngOnInit() {
        if (!this.dealer)
            this.dealer = this.uow.dealers.createEntity({
                created: new Date(),
                dealerTermId: DealerTerm.Terms.COD,
            }) as Dealer;
    }

    async save(send: boolean = false) {
        const result = await this.validate();
        if (!result) return;

        this.appInfo.pleaseWaitShow();
        await this.uow.commit([this.dealer]);
        this.result.next({ success: true, dealer: this.dealer, send: send });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\r\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\r\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false, send: false });
    }
}
